<template>
  <div class="api-key-card-validity">
    <dt class="sr-only">Validity</dt>
    <dd class="api-key-card-validity__value">
      <span class="api-key-card-validity__label" :class="labelClass">
        {{ label }}
      </span>
      <BittsProgressBar
        :width="`${percent}%`"
        :color="color"
        class="api-key-card-validity__bar"
      />
    </dd>
  </div>
</template>

<script setup lang="ts">
import { BittsProgressBar } from '@crossbeam/bitts';

import { computed } from 'vue';

const { label, percent, color } = defineProps<{
  label: string;
  percent: number;
  color: 'secondary' | 'warning' | 'danger';
}>();

const labelClass = computed(
  () =>
    ({
      secondary: 'text-neutral-text-strong',
      warning: 'text-warning-text',
      danger: 'text-danger-text',
    })[color],
);
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";

.api-key-card-validity {
  @apply ml-auto shrink-0;
}

.api-key-card-validity__value {
  @apply flex flex-col items-end gap-4 m-0;
}

.api-key-card-validity__label {
  @apply text-base font-medium;
}

.api-key-card-validity__bar {
  @apply w-[180px];
}
</style>
